import { toast } from "react-toastify";
import { getAllPeerConfiguration } from "../thunk";
import {  fetchdeletePeerConfigurationFailure, fetchdeletePeerConfigurationSuccess } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { PEER_CONFIGURATION_API } from "../../constants/constants";

export const deletePeerConfiguration = (id,setLoading, navigate) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${PEER_CONFIGURATION_API}/${id}`, 'DELETE').then((response) => {
        if (!response.error) {
            dispatch(fetchdeletePeerConfigurationSuccess(response))
            setLoading(false)
            dispatch(getAllPeerConfiguration(setLoading))
            toast.success(`Peer Configuration Deleted Successfully`)
        }
        if (response.error) {
            dispatch(fetchdeletePeerConfigurationFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
    }).catch((errorResp) => { })
}